import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import i18n from '@/plugins/i18n';
import router from "./router";
import resources from "./service/index"
import VueCarousel from 'vue-carousel';
import VueGtm from 'vue-gtm';
import Cookies from 'js-cookie';
import CountryFlag from 'vue-country-flag'
import authSession from './service/auth-session';
import localeService from './service/locale';
import { getSubdomainCode } from './service/subdomain';

const CookiePlugin = {
    install(Vue) {
        Vue.prototype.$cookies = Cookies;
    }
};

Vue.use(CookiePlugin);
Vue.use(resources);
Vue.use(VueCarousel);
Vue.component('country-flag', CountryFlag)
Vue.config.productionTip = false

Vue.prototype.$commons = {

}

authSession.checkSession()
localeService.initLocale()

Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM_ID,
  defer: false,
  enabled: true,
  debug: false,
  loadScript: true,
  vueRouter: router,
  trackOnNextTick: false,
});
const appEl = document.getElementById('app')
// element children only (not childNodes): the un-prerendered placeholder in
// public/index.html still ships as an HTML comment on the dev server, which
// dev-mode (unminified) markup keeps but childNodes would count as content
const hasPrerenderedContent = !!(appEl && appEl.children.length > 0)
// A subdomain-form address request (e.g. myapp.localhost) lands on the
// prerendered marketing route's path ('/'), but router.js's beforeEach
// rewrites it to a different route (the resolved address) — hydrating the
// mismatched marketing markup for it would only reproduce the same kind of
// hydration error the fallback below exists for. Skip hydration for it
// proactively instead of waiting for that error.
const isSubdomainRootRequest = window.location.pathname === '/' && !!getSubdomainCode()

function mountApp (hydrating) {
  return new Vue({
    i18n,
    vuetify,
    router,
    render: h => h(App)
  }).$mount('#app', hydrating)
}

if (hasPrerenderedContent && !isSubdomainRootRequest) {
  try {
    mountApp(true)
  } catch (e) {
    // Hydration can throw instead of gracefully bailing (observed with
    // Vuetify's detachable v-menu/v-dialog content moved outside the
    // template's DOM position after the prerendered snapshot was taken).
    // Reset to the same clean state a non-prerendered route mounts into,
    // rather than risk resuming into a partially-patched DOM.
    console.error('[hydration] falling back to full client render:', e)
    appEl.innerHTML = ''
    mountApp(false)
  }
} else {
  if (isSubdomainRootRequest && appEl) appEl.innerHTML = ''
  mountApp(false)
}
